// extracted by mini-css-extract-plugin
export var fullscreen = "index-module--fullscreen--bf9dc";
export var isReady = "index-module--isReady--76cb9";
export var loading = "index-module--loading--c1ac4";
export var pagesContainer = "index-module--pagesContainer--5e692";